<template>
  <iTooltip
    v-if="hasTooltip"
    :placement="placement"
    :options="options"
    transfer
  >
    <IconFn
      :type="icon"
      :size="size" />
    <span
      slot="content"
      style="white-space: normal;">
      {{ tooltip }}
    </span>
  </iTooltip>
  <IconFn
    v-else
    :size="size"
    :type="icon"
    @mouseenter="onHover()" />
</template>
<script>

import IconFn from '@/components/iview/functional/Icon.vue';

export default {
  name: 'IconCell',
  components: { IconFn },
  inject: ['table'],
  props: {
    icon: { type: String, required: true },
    size: { type: [Number, String], default: undefined },

    tooltip: { type: String, default: undefined },
    placement: { type: String, default: undefined },
    options: { type: Object, default: undefined },
  },
  data() {
    return {
      active: false,
    };
  },
  computed: {
    hasTooltip() { return this.tooltip && this.active; },
  },
  methods: {
    onHover() {
      this.active = true;
    },
  },
};
</script>
